import React, { Component } from "react";
import api from "../../api";
import { Link } from "react-router-dom";
import { Chart } from "primereact/chart";
import {downloadArrears} from '../../actions/institutionActions'

class AccountsReport extends Component {
  constructor() {
    super();
    this.state = {
      inArrears: null,
      upToDate: null,
      chartData:""
    };
    this.getByArrears = this.getByArrears.bind(this);
    this.generateArrearsChart = this.generateArrearsChart.bind(this);
    this.getArrears=this.getArrears.bind(this);
  }

  componentDidMount() {
    this.getByArrears();
  }

  getByArrears() {
      ///const tuId=this.props.security.user.tradeUnion.id;
    const arrearUrl = "/api/arrears-stats/"+1+"/"+true;
    const uptodateUrl =  "/api/arrears-stats/"+1+"/"+false;

    api.get(arrearUrl).then((response) => {
      const data = response.data;
      this.setState({ inArrears: data });
    });

    api.get(uptodateUrl).then((response) => {
      const data = response.data;
      this.setState({ upToDate: data });
    });

    
  }


  generateArrearsChart() {

    
    this.chartData = {
      labels: ["In Arrears", "Up To Date"],
      datasets: [
        {
          data: [this.state.inArrears, this.state.upToDate],
          backgroundColor: ["#FF6384", "#FFCE56"],
          hoverBackgroundColor: ["#64B5F6", "#81C784"],
        },
      ],
    };

    this.lightOptions = {
      legend: {
        labels: {
          fontColor: "#495057",
        },
      },
    };
   
  }

  
getArrears=()=>{
  downloadArrears(1);
}

  render() {
   this.generateArrearsChart();
    return (
      <div className="row">
        <div className="col-sm-6 m-auto">
        <div className="card mt-4" style={{ width: "900px" }}>
            <div className="card-header mb-3">
              <h5 className="m-auto">Arrears Statistics</h5>
            </div>
        
             <Chart
                type="pie"
                data={this.chartData}
                options={this.lightOptions}
              />

            
            <div className="card-footer">
              <Link>               
                <span onClick={this.getArrears}>Download Arrears list</span>
              </Link>
            </div>
          </div> 
        </div>
      </div>
    );
  }
}

export default AccountsReport;
